import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation();
  return (
    <>
        <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">{t('support_contact')}<a href="mailto:soporte@cef-technology.com">soporte@cef-technology.com</a></span>
            </div>
        </footer>
    </>
  )
}

export default Footer